import { Classes, Colors } from "@blueprintjs/core";
import {
  DataTable2,
  IDataTableColumn,
  SortKeysObject,
  useGridState,
} from "nsitools-react";
import * as React from "react";
import { css } from "styled-components";
import { useCommonHooks } from "../../hooks";

export interface ITransfertListDataTableProps<T> {
  columns: IDataTableColumn[];
  onSelectionChanges: (selection: Array<T>) => void;
  gridData: Array<T>;
  loading: boolean;
  sortKeys?: SortKeysObject;
}

export function TransfertListDataTable<T>({
  columns,
  onSelectionChanges,
  gridData,
  loading,
  sortKeys,
}: ITransfertListDataTableProps<T>) {
  const tableState = useGridState<any>({
    serverMode: false,
    availablePageSizes: [10],
    pageSize: 10,
    enablePagination: true,
    enableFilter: false,
    sortKeys: sortKeys,
  });

  const { setData } = tableState;
  const { tUnsafe } = useCommonHooks();

  React.useEffect(() => {
    setData(gridData);
  }, [gridData, setData]);

  const [selectedItems, setSelectedItems] = React.useState<Array<T>>([]);

  const onRowClick = React.useCallback(
    (item: T) => {
      if (selectedItems.includes(item)) {
        setSelectedItems((previous) => previous.filter((i) => i !== item));
      } else {
        setSelectedItems((previous) => [...previous, item]);
      }
    },
    [selectedItems]
  );

  React.useEffect(() => {
    onSelectionChanges(selectedItems);
  }, [selectedItems, onSelectionChanges]);

  const customizeRowStyleCallback = React.useCallback(
    (d: T) => {
      const isSelected = selectedItems.includes(d);

      return css`
        & * {
          color: ${isSelected ? Colors.WHITE : Colors.BLACK} !important;
        }

        & td {
          vertical-align: middle !important;

          & .${Classes.CONTROL} {
            margin: 0;
          }
        }

        /* Change color for customer */
        background-color: ${isSelected ? Colors.BLUE1 : "transparent"};
      `;
    },
    [selectedItems]
  );

  return (
    <DataTable2
      tableState={tableState}
      columns={columns}
      onRowClick={onRowClick}
      customizeRowStyle={customizeRowStyleCallback}
      loading={loading}
      translateFunc={tUnsafe}
    />
  );
}
